import type { Renderable } from "@/components/controls/grid/BmGridData";

/**
 * Extracts a prefix from context renderer metadata
 */
export function prefix(
  context: Renderable,
  item: unknown,
  value: unknown
): string | undefined {
  const renderingOpts = context.rendererMetadata;
  if (renderingOpts && renderingOpts.prefixExtractor) {
    if (typeof renderingOpts.prefixExtractor === "function") {
      return renderingOpts.prefixExtractor(item, value);
    } else if (typeof renderingOpts.prefixExtractor === "string") {
      return renderingOpts.prefixExtractor;
    }
  }
  return undefined;
}

/**
 * Extracts a suffix from context renderer metadata
 */
export function suffix(
  context: Renderable,
  item: unknown,
  value: unknown
): string | undefined {
  const renderingOpts = context.rendererMetadata;
  if (renderingOpts && renderingOpts.suffixExtractor) {
    if (typeof renderingOpts.suffixExtractor === "function") {
      return renderingOpts.suffixExtractor(item, value);
    } else if (typeof renderingOpts.suffixExtractor === "string") {
      return renderingOpts.suffixExtractor;
    }
  }
  return undefined;
}
